import { NetworkStatus, PluginListenerHandle } from '@absis/core-plugins';
import {
    currentNetworkStatus,
    removeNetworkListeners,
  } from './utils';

  /**
 * Network plugin
 *
 */
export let onlineListener: ()=>void;
export const CBNetwork = {
  getStatus(): Promise<NetworkStatus> {
    return currentNetworkStatus();
  },

  addListener(
    eventName: 'networkStatusChange',
    listenerFunc: (status: NetworkStatus) => void
  ): PluginListenerHandle {
    onlineListener = async () => {
      if (eventName === 'networkStatusChange') listenerFunc(await currentNetworkStatus());
    };
    window.addEventListener('online', onlineListener);
    window.addEventListener('offline', onlineListener);
    return {
      remove: () => {
        removeNetworkListeners(onlineListener);
      },
    };
  },

  removeAllListeners(): void {
    removeNetworkListeners(onlineListener);
  },
};
